import { BuildingSpecification } from '../BuildingSpecification';

export const setBuildingTitle =
  (buildingTitle?: string) =>
  (buildingSpecification: BuildingSpecification): BuildingSpecification => ({
    ...buildingSpecification,
    title: buildingTitle
  });
